import { TmTableElementManagerError } from '@/core/error/table/tableManager/tmTableElementManagerError'

export class TmTableElementManagerFactoryNotFoundError extends TmTableElementManagerError {
  public name = 'TmTableElementManagerFactoryNotFoundError'
}
